(() => {
jQuery(function($1) {
    var timeslots = {};
    // Location session
    $1(".location-search__results").on("click", ".location-search__card", function(event) {
        event.preventDefault();
        // If location has an external planner
        var href = $1(this).attr("href");
        if (href) window.location.replace($1(this).attr("href"));
        else {
            var location = JSON.stringify({
                "location": {
                    "page-id": $1(this).attr("data-page-id")
                }
            });
            $cb410d0bd6a0b088$var$SetFlowSessionData(location, function() {
                window.location.href = flowUrls[2];
            });
        }
    });
    // Checklist session
    $1(".checklist__form").change(function() {
        var tasks = {};
        $1(".checklist__form input:checked").each(function() {
            var element = $1(this);
            if (element.attr("id") == "checklist-text") tasks[element.attr("id")] = $1(".checklist__textarea").val();
            else tasks[element.attr("id")] = element.val();
        });
        tasks = JSON.stringify({
            "tasks": tasks
        });
        $cb410d0bd6a0b088$var$SetFlowSessionData(tasks);
    });
    //timeslots session
    $1(".flow-day__checkbox").change(function() {
        const selectedDate = $1(".date-picker__calendar").val();
        $1(".flow-day__checkbox:checked").each(function() {
            var element = $1(this);
            timeslots = `${selectedDate} - ${element.val()}`;
        });
    });
    $1("#privacyCheckbox").change(function(event) {
        event.preventDefault();
        if ($1(this).prop("checked")) $1(".flow__end button").prop("disabled", false); // Element(s) are now enabled.
        else $1(".flow__end button").prop("disabled", true); // Element(s) are now disabled.
        console.log(timeslots);
        $1(".timeslot-field input").val(timeslots);
        if ($1.isEmptyObject(timeslots)) {
            $1(".gfield.application-type select").val("Offerte aanvraag");
            console.log("Offerte");
        } else {
            $1(".gfield.application-type select").val("Afspraak aanvraag");
            console.log("Afspraak");
        }
    });
    $1("#flow-submit").click(function(event) {
        event.preventDefault();
        formid = $1(this).data("formid");
        $1("#gform_" + formid)[0].submit();
        // Disable button to prevent extra submissions
        $1("#flow-submit").addClass("button--loading");
        $1("#flow-submit").prop("disabled", true);
        // Enable button to allow submission after error
        var checkError = window.setInterval(function() {
            if ($1(".gform_submission_error").length > 0) {
                console.log("wow awatch out");
                $1("#flow-submit").removeClass("button--loading");
                $1("#flow-submit").prop("disabled", false);
                clearInterval(checkError);
            }
        }, 1000);
    });
});
function $cb410d0bd6a0b088$var$SetFlowSessionData(newData, callback) {
    data = {
        "action": "load_ajax_flow_session_handler",
        "session": load_ajax_flow_session_params.session,
        "new_data": newData
    };
    console.log("bestaande array" + load_ajax_flow_session_params.session);
    console.log("toevoeging array" + newData);
    $.ajax({
        url: load_ajax_flow_session_params.ajaxurl,
        data: data,
        type: "POST",
        success: function(data1, xhr) {
            if ($.isFunction(callback)) callback.call();
        },
        error: function(xhr) {
            console.log("nope.....");
        }
    });
} //end LoadLocationsWithAjax()

})();
//# sourceMappingURL=ajax-flow.js.map
